import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { isEqual } from 'lodash';
import { generateDisplayPositions, QuizEntryView as QuizEntry } from '@instructure/quiz-core';
import { CLEAR_ALL_INPUT_VALIDATION_ERRORS } from '@instructure/quiz-common';
export var QuizEntriesSection = /*#__PURE__*/function (_Component) {
  function QuizEntriesSection() {
    var _this;
    _classCallCheck(this, QuizEntriesSection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, QuizEntriesSection, [].concat(args));
    _defineProperty(_this, "state", {
      editQuizEntryToggle: -1,
      validationErrorsFromApi: {}
    });
    _defineProperty(_this, "handleValidationErrorsFromApi", function (errors) {
      _this.setState({
        validationErrorsFromApi: errors
      });
    });
    _defineProperty(_this, "clearValidationErrorsFromApi", function (inputId) {
      if (inputId === CLEAR_ALL_INPUT_VALIDATION_ERRORS) {
        _this.setState({
          validationErrorsFromApi: {}
        });
      }
      if (_this.state.validationErrorsFromApi[inputId]) {
        var newErrors = Object.assign({}, _this.state.validationErrorsFromApi);
        delete newErrors[inputId];
        _this.setState({
          validationErrorsFromApi: newErrors
        });
      }
    });
    _defineProperty(_this, "propsForQuizEntry", function (quizEntry, displayPosition) {
      return {
        displayPosition: displayPosition,
        draggingOnBuild: _this.props.isOver,
        editable: true,
        propsForQuizEntry: _this.propsForQuizEntry,
        quizEntries: _this.props.quizEntries,
        quizEntry: quizEntry,
        quizId: _this.props.quizId,
        isContentLockedByBlueprint: _this.props.isContentLockedByBlueprint,
        ref: _this.props.setQuizEntryRef(quizEntry.id),
        scrollKey: quizEntry.id,
        editQuizEntryToggle: _this.state.editQuizEntryToggle === quizEntry.id,
        onEditQuizEntryToggle: _this.onEditQuizEntryToggle,
        openRegradeModal: Function.prototype,
        handleValidationErrorsFromApi: _this.handleValidationErrorsFromApi,
        clearValidationErrorsFromApi: _this.clearValidationErrorsFromApi,
        validationErrorsFromApi: _this.state.validationErrorsFromApi
      };
    });
    _defineProperty(_this, "renderQuizEntry", function (quizEntry, displayPosition) {
      var ref = _this.props.setQuizEntryWrapperRef(quizEntry.id);
      var nextPosition = quizEntry.position + 1;
      nextPosition += quizEntry.hasNestedRecords ? quizEntry.positionSlots : 0;
      return /*#__PURE__*/React.createElement("div", {
        ref: ref,
        key: "".concat(quizEntry.id, "_build")
      }, /*#__PURE__*/React.createElement(QuizEntry, _this.propsForQuizEntry(quizEntry, displayPosition)), _this.props.renderAddContentPopover(_this.props.isOver, nextPosition));
    });
    _defineProperty(_this, "onEditQuizEntryToggle", function (value) {
      _this.setState({
        editQuizEntryToggle: value
      });
    });
    return _this;
  }
  _inherits(QuizEntriesSection, _Component);
  return _createClass(QuizEntriesSection, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var quizEntriesEqual = this.props.quizEntries.equals(nextProps.quizEntries);
      return !quizEntriesEqual || this.props.isOver !== nextProps.isOver || this.props.quizId !== nextProps.quizId || this.props.renderAddContentPopover !== nextProps.renderAddContentPopover || this.props.setQuizEntryRef !== nextProps.setQuizEntryRef || this.props.setQuizEntryWrapperRef !== nextProps.setQuizEntryWrapperRef || this.state.editQuizEntryToggle !== nextState.editQuizEntryToggle || !isEqual(this.state.validationErrorsFromApi, nextState.validationErrorsFromApi);
    }
  }, {
    key: "renderQuizEntries",
    value: function renderQuizEntries() {
      var _this2 = this;
      return generateDisplayPositions(this.props.quizEntries).map(function (quizEntry) {
        if (!quizEntry.record.entryType) return null;
        return _this2.renderQuizEntry(quizEntry.record, quizEntry.displayPosition);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderQuizEntries());
    }
  }]);
}(Component);
_defineProperty(QuizEntriesSection, "propTypes", {
  isContentLockedByBlueprint: PropTypes.bool.isRequired,
  isOver: PropTypes.bool.isRequired,
  quizId: PropTypes.string.isRequired,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  renderAddContentPopover: PropTypes.func.isRequired,
  setQuizEntryRef: PropTypes.func.isRequired,
  setQuizEntryWrapperRef: PropTypes.func.isRequired
});
export default QuizEntriesSection;